module.exports = "/_next/static/images/GearlessL-f1e94324c26b76ca36ff1f177491db9c.png";